import React, { useId, useEffect, useState } from 'react';
import { compose, render } from '@/utils/story-composer';
import InputService from '@/utils/input-service';
import { InputsEnum } from '@/enums/inputs';

function CheckboxInput({ identifier, labelContent, required = false, error_message: errorMessage }) {
	const [showError, setShowError] = useState(false);
	const [checked, setChecked] = useState(false);

	useEffect(() => {
		const inputService = InputService.getInstance();

		inputService.registerInputField(identifier, InputsEnum.CHECKBOX, '', required, isValid => {
			setShowError(!isValid);
		});

		setChecked(inputService.getInputValue(identifier));

		return () => {
			inputService.unregisterInputField(identifier);
		};
	}, []);

	const handleChange = value => {
		const inputService = InputService.getInstance();
		inputService.storeInputValue(identifier, value);
		setChecked(value);
	};

	const id = useId();
	return (
		<div className="w-full">
			<div className="relative w-full">
				<label htmlFor={`input_${id}`} className="flex align-center">
					<input
						id={`input_${id}`}
						type="checkbox"
						checked={checked}
						className="mr-2"
						onChange={() => handleChange(!checked)}
					/>
					{render(labelContent)}
				</label>
			</div>
			{showError && (
				<p id="outlined_error_help" className="mt-2 text-xs text-red-600 dark:text-red-400">
					<span className="font-medium">{errorMessage}</span>
				</p>
			)}
		</div>
	);
}

export default CheckboxInput;
compose('checkbox-input', CheckboxInput);
